import {Controller} from "@hotwired/stimulus"

// The sidebar form is server-rendered from the applied request, and it sits
// outside the permanent filter list, so each visit starts from what the report
// is actually using. A later choice that has not been applied shows above the button.
const IGNORED_FIELDS = new Set(["authenticity_token", "argument_request"])

export default class extends Controller {
  static targets = ["notice", "apply"]

  connect() {
    this.applied = this.signature()
    this.onEdit = () => this.refresh()
    this.element.addEventListener("input", this.onEdit)
    this.element.addEventListener("change", this.onEdit)
    this.refresh()
  }

  disconnect() {
    if (!this.onEdit) return
    this.element.removeEventListener("input", this.onEdit)
    this.element.removeEventListener("change", this.onEdit)
  }

  refresh() {
    const pending = this.signature() !== this.applied
    if (this.hasNoticeTarget) this.noticeTarget.classList.toggle("hidden", !pending)
    if (!this.hasApplyTarget) return
    if (pending) this.applyTarget.setAttribute("aria-label", "Apply filters, not yet applied")
    else this.applyTarget.removeAttribute("aria-label")
  }

  signature() {
    const parts = []
    for (const [key, value] of new FormData(this.element).entries()) {
      if (IGNORED_FIELDS.has(key)) continue
      parts.push(`${key}\n${value}`)
    }
    parts.sort()
    return parts.join("\n")
  }
}
